import { render } from "./LandingPage.vue?vue&type=template&id=3828b24c&scoped=true"
const script = {}

import "./LandingPage.vue?vue&type=style&index=0&id=3828b24c&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3828b24c"]])

export default __exports__